import React, { useState, useEffect, useRef } from 'react';
import './SigninSignupCarousel.css';
import { Button, Radio } from 'antd';
import {RightOutlined} from '@ant-design/icons'
import carouselContent from './carouselContent';

let mainCarouselDiv = {
    position: "absolute",
    maxWidth: "29.375rem",
    height: "212px",
    borderRadius: "20px",
    backgroundColor: "#FFFFFF",
    bottom: "60px",
    padding: "17px",
    boxSizing: "border-box",
};

let titleHolder = {
    display: "flex",
    alignItems: "center",
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    border: "3px solid #4D99EF"
};

const SigninSignupCarousel = () => {
    const [carouselIndexValue, setCarouselIndexValue] = useState(0);
    const intervalRef = useRef(null); // Ref to store the interval ID
    const indexValList = [0,1,2,3,4];

    const startTimer = () => {
        // Set a new interval
        intervalRef.current = setTimeout(() => {
            setCarouselIndexValue(prevIndex => (prevIndex + 1) % carouselContent.length);
        }, 5000); // Change every 5 seconds
    };

    useEffect(() => {
        startTimer(); // Start the timer when component mounts

        return () => {
            clearTimeout(intervalRef.current); // Cleanup on component unmount
        };
    }, [carouselIndexValue]);


    const handleClick = (e) => {
        setCarouselIndexValue(e.target.value);
    };

    const openInNewTab = (url)=>{
        if(url.length > 0){
            window.open(url, '_blank').focus();
        }
    }

    return (
        <div className='carousel'>
            <div style={mainCarouselDiv} className="carousel-item" key={carouselIndexValue}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={titleHolder}>
                        <img src={carouselContent[carouselIndexValue].src} style={{ margin: "0px auto", width: "20px", height: "20px" }} />
                    </div>
                    <p style={{ marginLeft: "10px", color: "#4D99EF", fontSize: "18px", fontWeight: "600" }}>{carouselContent[carouselIndexValue].title}</p>
                </div>
                <div>
                    <p id="dynamic-truncate" style={{ marginTop: "10px", fontFamily: 'Nunito Sans', fontSize: "16px", fontWeight: "400", lineHeight: "30px", color: "#9B9B9B" }}>
                        {carouselContent[carouselIndexValue].description}
                    </p>
                </div>
                <Button
                    onClick={() => openInNewTab(carouselContent[carouselIndexValue].url)}
                    type="primary"
                    style={{display: "flex", alignItems: "center", justifyContent: "space-between"}} 
                    className='carousel-explore'
                >
                    EXPLORE
                    <RightOutlined />
                </Button>
            </div>
            <Radio.Group className="carousel-radio-group" style={{ position: "absolute", bottom: "25px" }} onChange={handleClick} value={carouselIndexValue}>
                {indexValList.map((_,index)=>(
                    <Radio key={index} value={index} />
                ))}
                {/* <Radio value={0}></Radio>
                <Radio value={1}></Radio>
                <Radio value={2}></Radio>
                <Radio value={3}></Radio>
                <Radio value={4}></Radio> */}
            </Radio.Group>
            {/* <div style={{ position: "absolute", bottom: "25px" }}>
                {carouselContent.map((_, index) => (
                    <img
                        key={index}
                        className='carouselScrollImg'
                        src={carouselIndexValue === index ? selectedCarousel : notSelected}
                        onClick={() => handleClick(index)}
                    />
                ))}
            </div> */}
        </div>
    );
}

export default SigninSignupCarousel;
